import { createContext, useContext } from 'react';

import * as graphql from '@treams/treams-network';

const Context = createContext<Pick<graphql.Workspace, 'id'>>({ id: '' });

export const WorkspaceProvider = Context.Provider;

export const useWorkspace = (): Pick<graphql.Workspace, 'id'> => {
	return useContext(Context);
};

export const useWorkspaceAlias = (): string => {
	if (
		process.env.NODE_ENV === 'development' &&
		!window.location.hostname.endsWith('.testing-ontreams.com') &&
		!window.location.hostname.endsWith('.ontreams.com')
	) {
		return import.meta.env.VITE_WORKSPACE_OVERRIDE ?? 'testenv';
	}

	if (window.location.hostname.endsWith('.dev')) {
		return 'testenv';
	}

	return window.location.hostname.split('.')[0];
};
